import DeleteSponsorship from "./DeleteSponsorship";

export default DeleteSponsorship